class AnalyticsController {
  constructor(AnalyticsService, $q) {
    "ngInject"

    this.analyticsService = AnalyticsService;
    this.$q = $q;
  }

  $onInit() {
    this.isLoading = true;

    const revenuePromise = this.analyticsService.getRevenueData();
    const revenueYoYPromise = this.analyticsService.getRevenueYearOverYearData();
    const revenueFYoYPromise = this.analyticsService.getRevenueFinancialYearOverYearData();
    const refundsPromise = this.analyticsService.getRefundsData();
    const refundAmountsPromise = this.analyticsService.getRefundsAmountData();
    const clientRefundsPromise = this.analyticsService.getClientRefundsData();
    const recentRevenuePromise = this.analyticsService.getRecentRevenueData();
    const newVersusRecurringRevenuePromise = this.analyticsService.getNewVersusRecurringRevenueData();
    const helperNewVersusRecurringRevenuePromise = this.analyticsService.getHelperNewVersusRecurringRevenueData();
    const getGeneralStatsPromise = this.analyticsService.getGeneralStatsData();
    const getJobValueOverTimePromise = this.analyticsService.getJobValueOverTimeData();
    // const jobsSuccessRatePromise = this.analyticsService.getJobsSuccessRateData();
    const recentRevenueByDevicePromise = this.analyticsService.getRecentRevenueByDeviceData();
    // const revenueByDevicePromise = this.analyticsService.getRevenueByDeviceData();
    const getRevenueBreakdownPromise = this.analyticsService.getRevenueBreakdownData();
    const getNewRevenueBreakdownPromise = this.analyticsService.getNewRevenueBreakdownData();
    const getUpsellBreakdownPromise = this.analyticsService.getUpsellBreakdown();
    const getAvgTrnValuePromise =  this.analyticsService.getAvgTrnValueData();
    const payingCustomersOvertimePromise = this.analyticsService.getPayingCustomersOvertimeData();
    const getRevenueByStatePromise = this.analyticsService.getRevenueByStateData();
    const getTopRevenuePromise = this.analyticsService.getTopRevenueData();
    const getMonthlyRevenuePromise = this.analyticsService.getMonthlyRevenueData();
    const payingCustomersPromise = this.analyticsService.getPayingCustomersData();
    const nzRevenueByRegionPromise = this.analyticsService.getNzRevenueByRegionData();
    const getMonthlyActiveUsersPromise = this.analyticsService.getMonthlyActiveUsersData();
    const arruPromise = this.analyticsService.getArruData();
    const jobsValueByFinancialYearPromise = this.analyticsService.getJobValueByFinancialYearData();
    const getBusinessRevenueBreakdownPromise = this.analyticsService.getBusinessRevenueBreakdownData();
    const getHelperRevenueBreakdownPromise = this.analyticsService.getHelperRevenueBreakdownData();
    const getRevenueFinancialYearOverYearBreakdownPromise = this.analyticsService.getRevenueFinancialYearOverYearBreakdownData();

    this.$q.all([arruPromise, getMonthlyActiveUsersPromise, revenuePromise, revenueYoYPromise, revenueFYoYPromise, getRevenueBreakdownPromise, recentRevenuePromise, newVersusRecurringRevenuePromise, getGeneralStatsPromise, recentRevenueByDevicePromise, refundsPromise, getAvgTrnValuePromise, payingCustomersOvertimePromise, getRevenueByStatePromise, getNewRevenueBreakdownPromise, getUpsellBreakdownPromise, getTopRevenuePromise, getMonthlyRevenuePromise,
      payingCustomersPromise, nzRevenueByRegionPromise, getJobValueOverTimePromise, jobsValueByFinancialYearPromise, helperNewVersusRecurringRevenuePromise, getBusinessRevenueBreakdownPromise, getHelperRevenueBreakdownPromise, getRevenueFinancialYearOverYearBreakdownPromise, refundAmountsPromise, clientRefundsPromise]).then(data => {

      const [arruResponse, monthlyActiveUsersResponse, revenueResponse, revenueYoYResponse, revenueFYoYResponse, revenueBreakdownResponse, recentRevenueResponse, newVersusRecurringRevenueResponse, getGeneralStatsResponse, recentRevenueByDeviceResponse, refundsResponse, getAvgTrnValueResponse, payingCustomersOvertimeResponse, revenueByStateResponse, newRevenueBreakdownResponse, getUpsellBreakdownResponse, getTopRevenueResponse, getMonthlyRevenueResponse,
        payingCustomersResponse, nzRevenueByRegionResponse, getJobValueOverTimeResponse, jobsValueByFinancialYearResponse, helperNewVersusRecurringRevenueResponse, getBusinessRevenueBreakdownResponse, getHelperRevenueBreakdownResponse, revenueFYoYBreakdownResponse, refundAmountsResponse, clientRefundsResponse] = data;

      this.setMetricsChartOptions(monthlyActiveUsersResponse, arruResponse);

      this.setRevenueChartOptions(revenueResponse, getMonthlyRevenueResponse);

      this.setRevenueByStateChartOptions(revenueByStateResponse);

      this.setNzRevenueByRegionChartOptions(nzRevenueByRegionResponse);

      this.setRevenueYoYChartOptions(revenueYoYResponse, revenueFYoYResponse, revenueFYoYBreakdownResponse);

      this.setRevenueBreakdownChartOptions(revenueBreakdownResponse);

      this.setNewRevenueBreakdownChartOptions(newRevenueBreakdownResponse);

      this.setUpsellBreakdownChartOptions(getUpsellBreakdownResponse);

      this.setRefundsChartOptions(refundsResponse);

      this.setRefundsAmountChartOptions(refundAmountsResponse);

      this.setClientRefundsChartOptions(clientRefundsResponse);

      this.setRecentRevenueChartOptions(recentRevenueResponse);

      this.setRevenueByDeviceOptions(recentRevenueByDeviceResponse);

      this.setJobValueOverTimeOptions(getJobValueOverTimeResponse, jobsValueByFinancialYearResponse);

      this.setNewVersusRecurringRevenueOptions(newVersusRecurringRevenueResponse, helperNewVersusRecurringRevenueResponse);

      this.setGeneralStatsOptions(getGeneralStatsResponse);

      // this.setJobsSuccessRateChartOptions(jobsSuccessRateResponse);

      this.setAvgTrnvalueChartOptions(getAvgTrnValueResponse);

      this.setPayingCustomersOvertimeOptions(payingCustomersOvertimeResponse);

      this.setTopRevenueOptions(getTopRevenueResponse);

      this.setPayingCustomersOptions(payingCustomersResponse);

      this.setBusinessRevenueBreakdownChartOptions(getBusinessRevenueBreakdownResponse);

      this.setHelperRevenueBreakdownChartOptions(getHelperRevenueBreakdownResponse);

      this.isLoading = false;
    })
  }

  setMetricsChartOptions(monthlyActiveUsers, arru) {
    var template = "#: text #";
    var dateFormat = {months: "MMM 'yy"};

    var numberFormat = (args) => {
      const date = kendo.toString(new Date(args.category), 'MMM yyyy');
      return date + ' - ' + kendo.toString(args.value, 'n0');
    };
    this.monthlyActiveUsersOptions = this.analyticsService.getChartOptions("Monthly Active Users", monthlyActiveUsers.series, monthlyActiveUsers.categories, "{0:n0}", template, dateFormat, "n0");


    var curFormat = (args) => {
      const date = kendo.toString(new Date(args.category), 'MMM yyyy');
      return date + ' - ' + kendo.toString(args.value, 'c0');
    };
    const revenue = [];
    revenue.push(arru.series[0]);
    this.revenueOvertimeOptions = this.analyticsService.getChartOptions("Revenue", revenue, arru.categories, "{0:C0}", template, dateFormat, "c0");

    var curFormat2 = (args) => {
      const date = kendo.toString(new Date(args.category), 'MMM yyyy');
      return date + ' - ' + kendo.toString(args.value, 'c2');
    };
    const arruSeries = [];
    arruSeries.push(arru.series[1]);
    this.averageRevenuePerUserOptions = this.analyticsService.getChartOptions("Average Revenue Per User", arruSeries, arru.categories, "{0:C2}", template, dateFormat, "c2");
  }

  setPayingCustomersOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {months: "MMM 'yy"};

    const clientsChurn = [];
    clientsChurn.push(data.series[0]);
    clientsChurn.push(data.series[1]);
    clientsChurn.push(data.series[2]);

    const providersChurn = [];
    providersChurn.push(data.series[3]);
    providersChurn.push(data.series[4]);
    providersChurn.push(data.series[5]);

    var parsedCats = data.categories.map( (item) => kendo.toString(new Date(item), "yy-MM"));
    const clientTooltipTemplate = (e) => {
      const datePoint = kendo.toString(e.category, "yy-MM");
      const idx = parsedCats.indexOf(datePoint);

      const payingSeries = clientsChurn[0];
      const cancelledSeries = clientsChurn[1];
      const deletedSeries = clientsChurn[2];

      let churn = 0;
      if (payingSeries.data[idx] > 0)
        churn = (cancelledSeries.data[idx] + deletedSeries.data[idx]) / payingSeries.data[idx];

      let ratio = kendo.toString(churn, "p");
      return kendo.toString(e.category, "MMM yyyy") + " - Churn: " + ratio;
    };

    const providerTooltipTemplate = (e) => {
      const datePoint = kendo.toString(e.category, "yy-MM");
      const idx = parsedCats.indexOf(datePoint);

      const payingSeries = providersChurn[0];
      const cancelledSeries = providersChurn[1];
      const deletedSeries = providersChurn[2];

      let churn = 0;
      if (payingSeries.data[idx] > 0)
        churn = (cancelledSeries.data[idx] + deletedSeries.data[idx]) / payingSeries.data[idx];

      let ratio = kendo.toString(churn, "p");
      return kendo.toString(e.category, "MMM yyyy") + " - Churn: " + ratio;
    };
    this.payingClientsChurnOptions = this.analyticsService.getChartOptions("Paying Parents Churn", clientsChurn, data.categories, format, template, dateFormat, clientTooltipTemplate);
    this.payingProvidersChurnOptions = this.analyticsService.getChartOptions("Paying Helpers Churn", providersChurn, data.categories, format, template, dateFormat, providerTooltipTemplate);
}

  setTopRevenueOptions(data) {
    this.topRevenueOptions = {
        title: {
            text: 'Hall of Fame'
        },
        theme: "silver",
        legend: {
            visible: false
        },
        seriesDefaults: {
            type: "column",
            labels: {
              visible: true,
              format: "{0:c0}"
            }
        },
        series: data.series,
        valueAxis: {
            labels: {
                format: "{0:nc}"
            },
            line: {
                visible: false
            },
        },
        categoryAxis: {
            categories: data.categories,
            labels: {
                template: "#= kendo.toString(new Date(value), 'ddd d MMM yy') #",
            },
            line: {
                visible: false
            },
        },
        tooltip: {
            visible: true,
            format: "{0}%",
            template: "#= series.name #: #= kendo.toString(value, 'c0') #"
        }
    };
  }

  setPayingCustomersOvertimeOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {months: "MMM 'yy"};

    var parsedCats = data.categories.map( (item) => kendo.toString(new Date(item), "yy-MM"));
    const tooltipTemplate = (e) => {
      var idx = parsedCats.indexOf(kendo.toString(e.category, "yy-MM"));

      var activeSeries = data.series[e.series.index];
      var relatedSeries = data.series[0];

      var relatedItem = relatedSeries.data[idx];
      var total = relatedItem;

      var ratio = kendo.toString(e.dataItem.value / total, "p");
      return ratio;
    };

    this.payingCustomersOvertimeOptions = this.analyticsService.getChartOptions("New/Recurring Transactions", data.series, data.categories, format, template, dateFormat, tooltipTemplate);
  }

  setAvgTrnvalueChartOptions(data) {
    this.avgTrnValueOptions =  {
        title: {
            text: 'Average Transaction Value'
        },
        theme: "silver",
        legend: {
            position: "top",
            visible: false
        },
        seriesDefaults: {
            type: "column",
            labels: {
              visible: true,
              format: "{0:c0}"
            }
        },
        series: data.series,
        valueAxis: {
            labels: {
                format: "{0:c0}"
            },
            line: {
                visible: true
            },
        },
        categoryAxis: {
            categories: data.categories,
            labels: {
                template: "#= kendo.toString(new Date(value), 'MMM yy') #",
            },
            line: {
                visible: true
            },
        },
        tooltip: {
            visible: true,
            format: "{0}%",
            template: "#= series.name #: #= kendo.toString(value, 'c0') #"
        }
    };
  }

  setJobsSuccessRateChartOptions(data) {
    var format = "{0:p0}";
    var template = "#: text #";
    var dateFormat = {months: "MMM 'yy"};

    this.jobsSuccessRateoptions = this.analyticsService.getChartOptions("Jobs Success Rate", data.series, data.categories, format, template, dateFormat);
  }

  setRevenueChartOptions(data, monthlyRevenueData) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    var totalRevenueSeries = [];
    totalRevenueSeries.push(data.series[0]);
    totalRevenueSeries.push(data.series[1]);
    totalRevenueSeries.push(data.series[2]);

     this.totalRevenueChartOptions = this.analyticsService.getChartOptions("Revenue", totalRevenueSeries, data.categories, format, template, dateFormat);

     var revenueByCountrySeries = [];
     revenueByCountrySeries.push(data.series[0]);
     revenueByCountrySeries.push(data.series[3]);
     revenueByCountrySeries.push(data.series[4]);
     this.reveuneByCountryChartOptions = this.analyticsService.getChartOptions("Revenue by Country", revenueByCountrySeries, data.categories, format, template, dateFormat);

     var monthlyRevenueSeries = [];
     monthlyRevenueSeries.push(monthlyRevenueData.series[0]);
     monthlyRevenueSeries.push(monthlyRevenueData.series[1]);
     // monthlyRevenueSeries.push(monthlyRevenueData.series[2]);
     // monthlyRevenueSeries.push(monthlyRevenueData.series[3]);
     monthlyRevenueSeries.push(monthlyRevenueData.series[4]);
     this.monthlyRevenueChartOptions = this.analyticsService.getChartOptions("Net Monthly Revenue", monthlyRevenueSeries, data.categories, format, template, dateFormat);
  }

  setRevenueByStateChartOptions(data) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

     this.revenueByStateChartOptions = this.analyticsService.getChartOptions("Australian Revenue by State", data.series, data.categories, format, template, dateFormat);
  }

  setNzRevenueByRegionChartOptions(data) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

     this.nzRevenueByRegionChartOptions = this.analyticsService.getChartOptions("New Zealand Revenue by Region", data.series, data.categories, format, template, dateFormat);
  }

  setRevenueYoYChartOptions(data, fdata, fdataBreakdown) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM"};

    const tooltipTemplate = (e) => {
      return kendo.toString(e.value, 'C0');
    };

     this.revenueYoYChartOptions = this.analyticsService.getChartOptions("Revenue YoY", data.series, data.categories, format, template, dateFormat, tooltipTemplate);
     this.revenueFYoYChartOptions = this.analyticsService.getChartOptions("Revenue FYoY", fdata.series, fdata.categories, format, template, dateFormat, tooltipTemplate);
     this.revenueFYoYSummaryChartOptions = this.getColumnChartOptions("Revenue", fdata, 1);

     const newRevenue = [];
     newRevenue.push(fdataBreakdown.series[0]);
     newRevenue.push(fdataBreakdown.series[1]);
     newRevenue.push(fdataBreakdown.series[2]);
     newRevenue.push(fdataBreakdown.series[3]);
     newRevenue.push(fdataBreakdown.series[4]);

     const recurringRevenue = [];
     recurringRevenue.push(fdataBreakdown.series[5]);
     recurringRevenue.push(fdataBreakdown.series[6]);
     recurringRevenue.push(fdataBreakdown.series[7]);
     recurringRevenue.push(fdataBreakdown.series[8]);
     recurringRevenue.push(fdataBreakdown.series[9]);

     this.newRevenueFYoYChartOptions = this.analyticsService.getChartOptions("New Revenue FYoY", newRevenue, fdata.categories, format, template, dateFormat, tooltipTemplate);
     this.recurringRevenueFYoYChartOptions = this.analyticsService.getChartOptions("Recurring Revenue FYoY", recurringRevenue, fdata.categories, format, template, dateFormat, tooltipTemplate);
  }

  getColumnChartOptions = (title, data, colorStyle) => {

    var categories = [];

    var ds = [];
    // var seriesColors = [
    //     "#007bc3",
    //     "#76b800",
    //     "#ffae00",
    //     "#ef4c00",
    //     "#a419b7",
    //     "#430b62"
    // ];

    var colors1 = [
        "#007bc3",
        "#007bc3",
        "#007bc3",
        "#007bc3",
        "#007bc3",
        "#76b800",
        "#a419b7",
        "#430b62"
    ];

    var colors2 = [
      "#ffae00",
      "#ffae00",
      "#ffae00",
      "#ffae00",
      "#ffae00",
      "#76b800",
      "#a419b7",
      "#430b62"
  ];

  var seriesColors = colorStyle == 1 ? colors1 : colors2;

    data.series.forEach( (s, index) => {
        ds.push({
            data: s.totalRevenue,
            category: s.name,
            color: seriesColors[index]
        });
        categories.push(s.name);
    });

    return {
        title: {
            text: title,
            position: "bottom"
        },
        dataSource: {
            data: ds
        },
        theme: "silver",
        legend: {
            position: "top"
        },
        seriesDefaults: {
            type: "column",
            labels: {
                visible: true,
                format: "{0:c0}",
                background: "transparent"
            }
        },
        series: [{
            field: "data",
            categoryField: "category",
            colorField: "color"
        }],
        valueAxis: {
            format: "{0:c0}",
            majorGridLines: {
                visible: true
            },
            visible: false
        },
        categoryAxis: {
            majorGridLines: {
                visible: true
            },
            line: {
                visible: false
            }
        }
    };
}

  setRevenueBreakdownChartOptions(data) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    // var revenueBreakdownSeries = [];
    // revenueBreakdownSeries.push(data.series[0]);
    // revenueBreakdownSeries.push(data.series[1]);
    // revenueBreakdownSeries.push(data.series[2]);
    // revenueBreakdownSeries.push(data.series[3]);
    // revenueBreakdownSeries.push(data.series[4]);

    //  this.revenueBreakdownChartOptions = this.analyticsService.getChartOptions("Revenue Breakdown", revenueBreakdownSeries, data.categories, format, template, dateFormat);

     var paygRevenueSeries = [];
     paygRevenueSeries.push(data.series[3]);
     paygRevenueSeries.push(data.series[4]);
     paygRevenueSeries.push(data.series[5]);
     paygRevenueSeries.push(data.series[6]);
     paygRevenueSeries.push(data.series[13]);
     this.paygRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("PAYG Revenue", paygRevenueSeries, data.categories, format, template, dateFormat);

     var familyRevenueSeries = [];
     familyRevenueSeries.push(data.series[18]);
     familyRevenueSeries.push(data.series[8]);
     familyRevenueSeries.push(data.series[9]); // Annual Childcare
     familyRevenueSeries.push(data.series[11]); // Annual Tutoring + Childcare
     familyRevenueSeries.push(data.series[26]); // Monthly Childcare
     // familyRevenueSeries.push(data.series[24]); /// Annual Agency

     var legacyRevenueSeries = [];
     legacyRevenueSeries.push(data.series[7]); // Annual Babysitting
     legacyRevenueSeries.push(data.series[12]);
     legacyRevenueSeries.push(data.series[10]);

     this.familySubscriptionRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("Family Subscription Revenue", familyRevenueSeries, data.categories, format, template, dateFormat);
     this.legacySubscriptionRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("Legacy Subscription Revenue", legacyRevenueSeries, data.categories, format, template, dateFormat);
  }

  setHelperRevenueBreakdownChartOptions(data) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    var helperRevenueSeries = [];
    helperRevenueSeries.push(data.series[0]);
    helperRevenueSeries.push(data.series[1]);
    helperRevenueSeries.push(data.series[2]);
    helperRevenueSeries.push(data.series[3]);

    this.helperSubscriptionRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("Helper Subscription Revenue", helperRevenueSeries, data.categories, format, template, dateFormat);
  }

  setBusinessRevenueBreakdownChartOptions(data) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    var businessRevenueSeries = [];
    businessRevenueSeries.push(data.series[0]);
    businessRevenueSeries.push(data.series[1]);
    businessRevenueSeries.push(data.series[2]);
    // businessRevenueSeries.push(data.series[3]);
    // businessRevenueSeries.push(data.series[4]);

    this.businessSubscriptionRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("Business Revenue", businessRevenueSeries, data.categories, format, template, dateFormat);
  }

  setNewRevenueBreakdownChartOptions(data) {
    var format = "{0:N0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    this.newRevenueBreakdownChartOptions = this.analyticsService.getChartOptions("New Transactions by Type", data.series, data.categories, format, template, dateFormat);
  }

  setUpsellBreakdownChartOptions(data) {
    var format = "{0:N0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    var oneOffSeries = [];
    oneOffSeries.push(data.series[0]);
    oneOffSeries.push(data.series[1]);
    oneOffSeries.push(data.series[2]);

    var recurringSeries = [];
    recurringSeries.push(data.series[3]);
    recurringSeries.push(data.series[4]);

    var auPairseries = [];
    auPairseries.push(data.series[5]);
    auPairseries.push(data.series[6]);

    var tutoringSeries = [];
    tutoringSeries.push(data.series[7]);
    tutoringSeries.push(data.series[8]);
    tutoringSeries.push(data.series[9]);

    var tutoringSeries2 = [];
    tutoringSeries2.push(data.series[10]);
    tutoringSeries2.push(data.series[11]);

    this.oneOffUpsellBreakdownChartOptions = this.analyticsService.getChartOptions("One-off Upsell Breakdown", oneOffSeries, data.categories, format, template, dateFormat);
    this.recurringUpsellBreakdownChartOptions = this.analyticsService.getChartOptions("Nannying Upsell Breakdown", recurringSeries, data.categories, format, template, dateFormat);
    this.auPairUpsellBreakdownChartOptions = this.analyticsService.getChartOptions("Au Pair Upsell Breakdown", auPairseries, data.categories, format, template, dateFormat);
    this.tutoringUpsellBreakdownChartOptions = this.analyticsService.getChartOptions("PS Tutoring Upsell Breakdown", tutoringSeries, data.categories, format, template, dateFormat);
    this.tutoringUpsell2BreakdownChartOptions = this.analyticsService.getChartOptions("HS Tutoring Upsell Breakdown", tutoringSeries2, data.categories, format, template, dateFormat);
  }

  setRefundsChartOptions(data) {
    var format = "{0:C}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    var series = [];
    series.push(data.series[1]);
    series.push(data.series[2]);

    this.refundsChartOptions = this.analyticsService.getChartOptions("Refunds Breakdown (Amount)", series, data.categories, format, template, dateFormat);
  }

  setRefundsAmountChartOptions(data) {
    var format = "{0:N0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalCount, 'N0') #";
    var dateFormat = {months: "MMM 'yy"};

    var series = [];
    series.push(data.series[1]);
    series.push(data.series[2]);

    this.refundAmountsChartOptions = this.analyticsService.getChartOptions("Refunds Breakdown (Count)", series, data.categories, format, template, dateFormat);
  }

  setClientRefundsChartOptions(data) {
    var format = "{0:C}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    this.clientRefundsChartOptions = this.analyticsService.getChartOptions("Client Refunds Breakdown (Amount)", data.series, data.categories, format, template, dateFormat);
  }

  setRecentRevenueChartOptions(data) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {days: "ddd dd"};
    var tooltipFormat = "C0";

    var totalRevenueSeries = [];
    // totalRevenueSeries.push(data.series[7]);
    totalRevenueSeries.push(data.series[0]);
    totalRevenueSeries.push(data.series[1]);
    totalRevenueSeries.push(data.series[11]);
    // totalRevenueSeries.push(data.series[6]);

    var desktopRevenue = [];
    desktopRevenue.push(data.series[2]);
    desktopRevenue.push(data.series[3]);

    var mobileRevenue = [];
    mobileRevenue.push(data.series[4]);
    mobileRevenue.push(data.series[5]);

    var dailyRevenueSeries = [];
    dailyRevenueSeries.push(data.series[9]);
    dailyRevenueSeries.push(data.series[7]);
    dailyRevenueSeries.push(data.series[10]);
    dailyRevenueSeries.push(data.series[8]);

    var dailyRevenueYoYSeries = [];
    dailyRevenueYoYSeries.push(data.series[9]);
    dailyRevenueYoYSeries.push(data.series[12]);

    var dailyRevenueByUserSeries = [];
    dailyRevenueByUserSeries.push(data.series[7]);
    dailyRevenueByUserSeries.push(data.series[8]);

    this.recentRevenueChartOptions = this.analyticsService.getChartOptions("Daily Revenue", dailyRevenueSeries, data.categories, format, template, dateFormat, tooltipFormat);
    // this.recentRevenueByTypeChartOptions = this.analyticsService.getChartOptions("Daily Revenue - By User", dailyRevenueByUserSeries, data.categories, format, template, dateFormat, tooltipFormat);
    this.recentRevenueByDeviceChartOptions = this.analyticsService.getChartOptions("Revenue by Device", totalRevenueSeries, data.categories, format, template, dateFormat, tooltipFormat);
    this.desktopRecentRevenuehartOptions = this.analyticsService.getChartOptions("Revenue on Desktop", desktopRevenue, data.categories, format, template, dateFormat, tooltipFormat);
    this.mobileRecentRevenuehartOptions = this.analyticsService.getChartOptions("Revenue on Mobile Web", mobileRevenue, data.categories, format, template, dateFormat, tooltipFormat);
    this.recentRevenueYoYChartOptions = this.analyticsService.getChartOptions("Daily Revenue YoY", dailyRevenueYoYSeries, data.categories, format, template, dateFormat, tooltipFormat);
  }

  setRevenueByDeviceOptions(data) {
    var format = "{0:N0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {weeks: "ddd dd MMM"};

    var totalRevenueSeries = [];
    totalRevenueSeries.push(data.series[0]);
    totalRevenueSeries.push(data.series[1]);

    var subscriptionDesktopRevenue = [];
    subscriptionDesktopRevenue.push(data.series[2]);
    subscriptionDesktopRevenue.push(data.series[3]);
    subscriptionDesktopRevenue.push(data.series[4]);

    var mobileSubscriptionRevenue = [];
    mobileSubscriptionRevenue.push(data.series[5]);
    mobileSubscriptionRevenue.push(data.series[6]);
    mobileSubscriptionRevenue.push(data.series[7]);
    mobileSubscriptionRevenue.push(data.series[8]);

    this.desktopSubscriptionRecentRevenueChartOptions = this.analyticsService.getChartOptions("First Transaction on Desktop", subscriptionDesktopRevenue, data.categories, format, template, dateFormat, '', 'weeks');

    this.mobileSubscriptionRecentRevenueChartOptions = this.analyticsService.getChartOptions("First Transaction on Mobile App", mobileSubscriptionRevenue, data.categories, format, template, dateFormat, '', 'weeks');
  }

  setJobValueOverTimeOptions(data, fdata) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

     this.jobValueOverTimeChartOptions = this.analyticsService.getChartOptions("GMV", data.series, data.categories, format, template, dateFormat);
     this.jobsValueFYoYChartOptions = this.getColumnChartOptions("GMV", fdata, 2);
  }

  setNewVersusRecurringRevenueOptions(data, helpersData) {
    var format = "{0:C0}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    var totalRevenueSeries = [];
    totalRevenueSeries.push(data.series[0]);
    totalRevenueSeries.push(data.series[1]);
    totalRevenueSeries.push(data.series[2]);

    var quarterlyRevenueSeries = [];
    quarterlyRevenueSeries.push(data.series[3]);
    quarterlyRevenueSeries.push(data.series[4]);
    quarterlyRevenueSeries.push(data.series[5]);

    var annualRevenueSeries = [];
    annualRevenueSeries.push(data.series[6]);
    annualRevenueSeries.push(data.series[7]);
    annualRevenueSeries.push(data.series[8]);

    var familyNewRevenueSeries = [];
    familyNewRevenueSeries.push(data.series[10]);
    familyNewRevenueSeries.push(data.series[12]);
    familyNewRevenueSeries.push(data.series[13]);
    familyNewRevenueSeries.push(data.series[14]);
    familyNewRevenueSeries.push(data.series[15]);
    familyNewRevenueSeries.push(data.series[16]);

    var familyRecurringRevenueSeries = [];
    familyRecurringRevenueSeries.push(data.series[11]);
    familyRecurringRevenueSeries.push(data.series[17]);
    familyRecurringRevenueSeries.push(data.series[18]);
    familyRecurringRevenueSeries.push(data.series[19]);
    familyRecurringRevenueSeries.push(data.series[20]);

    const helperNewRevenueSeries = [];
    helperNewRevenueSeries.push(helpersData.series[1]);
    helperNewRevenueSeries.push(helpersData.series[3]);
    helperNewRevenueSeries.push(helpersData.series[4]);
    helperNewRevenueSeries.push(helpersData.series[7]);

    const helperRecurringRevenueSeries = [];
    helperRecurringRevenueSeries.push(helpersData.series[2]);
    helperRecurringRevenueSeries.push(helpersData.series[5]);
    helperRecurringRevenueSeries.push(helpersData.series[6]);
    helperRecurringRevenueSeries.push(helpersData.series[8]);

    this.newVersusRecurringRevenueOptions = this.analyticsService.getChartOptions("New vs Recurring Revenue", totalRevenueSeries, data.categories, format, template, dateFormat);

    this.newVersusRecurringQuarterlyRevenueOptions = this.analyticsService.getChartOptions("Quarterly Subscriptions - New vs Recurring Revenue", quarterlyRevenueSeries, data.categories, format, template, dateFormat);
    this.newVersusRecurringAnnualRevenueOptions = this.analyticsService.getChartOptions("Annual Subscriptions - New vs Recurring Revenue", annualRevenueSeries, data.categories, format, template, dateFormat);

    this.familyNewRevenueOptions = this.analyticsService.getChartOptions("New Family Revenue", familyNewRevenueSeries, data.categories, format, template, dateFormat);
    this.familyRecurringRevenueOptions = this.analyticsService.getChartOptions("Recurring Family Revenue", familyRecurringRevenueSeries, data.categories, format, template, dateFormat);

    this.helperNewRevenueOptions = this.analyticsService.getChartOptions("New Helper Revenue", helperNewRevenueSeries, helpersData.categories, format, template, dateFormat);
    this.helperRecurringRevenueOptions = this.analyticsService.getChartOptions("Recurring Helper Revenue", helperRecurringRevenueSeries, helpersData.categories, format, template, dateFormat);
  }

  setGeneralStatsOptions(data) {
    var clientJourneySet = data.series[0];
    this.clientJourneyOptions = this.analyticsService.getFunnelChartOptions(clientJourneySet.name, clientJourneySet.data);

    var providerJourneySet = data.series[1];
    this.providerJourneyOptions = this.analyticsService.getFunnelChartOptions(providerJourneySet.name, providerJourneySet.data);

    var revenueAtGlanceSet = data.series[2];
    var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueAtGlanceSet.name, revenueAtGlanceSet.totalCount, revenueAtGlanceSet.totalRevenue);
    var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
    this.revenueAtGlanceOptions = this.analyticsService.getDonutChartOptions(revenueAtGlanceSet, titleFormat, labelFormat);

    var revenueByFrequencySet = data.series[4];
    var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueByFrequencySet.name, revenueByFrequencySet.totalCount, revenueByFrequencySet.totalRevenue);
    // var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
    var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
    this.revenueByFrequencyOptions = this.analyticsService.getDonutChartOptions(revenueByFrequencySet, "", labelFormat);

    var jobDistributionSet = data.series[3];
    titleFormat = kendo.format("{0}", jobDistributionSet.name, jobDistributionSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
    this.jobDistributionOptions = this.analyticsService.getDonutChartOptions(jobDistributionSet, titleFormat, labelFormat);

    var revenueBySourceSet = data.series[5];
    titleFormat = kendo.format("{0}", revenueBySourceSet.name, revenueBySourceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
    this.revenueBySourceOptions = this.analyticsService.getDonutChartOptions(revenueBySourceSet, "", labelFormat);

    var jobsByManagementTypeSet = data.series[19];
    titleFormat = kendo.format("{0}", jobsByManagementTypeSet.name, jobsByManagementTypeSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
    this.jobsByManagementTypeOptions = this.analyticsService.getDonutChartOptions(jobsByManagementTypeSet, "", labelFormat);

    var redemptionsBySourceSet = data.series[6];
    titleFormat = kendo.format("{0} - Redemptions: {1}", redemptionsBySourceSet.name, redemptionsBySourceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Redemptions', dataItem.value)#";
    this.redemptionsBySourceOptions = this.analyticsService.getDonutChartOptions(redemptionsBySourceSet, titleFormat, labelFormat);

    var jobsByDeviceSet = data.series[7];
    titleFormat = kendo.format("{0}", jobsByDeviceSet.name, jobsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
    this.jobsByDeviceOptions = this.analyticsService.getDonutChartOptions(jobsByDeviceSet, titleFormat, labelFormat);

    var ratingsByType = data.series[12];
    titleFormat = kendo.format("{0}", ratingsByType.name, ratingsByType.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Jobs', dataItem.value)#";
    this.ratingsByJobType = this.analyticsService.getDonutChartOptions(ratingsByType, titleFormat, labelFormat);

    var quarterlySubscriptionLegacyRenewals = data.series[13];
    titleFormat = kendo.format("{0} - Total: {1:n0}", quarterlySubscriptionLegacyRenewals.name, quarterlySubscriptionLegacyRenewals.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
    this.quarterlySubscriptionLegacyRenewalOptions = this.analyticsService.getDonutChartOptions(quarterlySubscriptionLegacyRenewals, titleFormat, labelFormat);

    var quarterlySubscriptionRenewals = data.series[14];
    titleFormat = kendo.format("{0} - Total: {1:n0}", quarterlySubscriptionRenewals.name, quarterlySubscriptionRenewals.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
    this.quarterlySubscriptionRenewalOptions = this.analyticsService.getDonutChartOptions(quarterlySubscriptionRenewals, titleFormat, labelFormat);

    var annualSubscriptionRenewals = data.series[15];
    titleFormat = kendo.format("{0} - Total: {1:n0}", annualSubscriptionRenewals.name, annualSubscriptionRenewals.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
    this.annualSubscriptionRenewalOptions = this.analyticsService.getDonutChartOptions(annualSubscriptionRenewals, titleFormat, labelFormat);

    var frequentRecurringJobs = data.series[16];
    titleFormat = kendo.format("{0} - Total: {1:n0}", frequentRecurringJobs.name, frequentRecurringJobs.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
    this.frequentRecurringJobsOptions = this.analyticsService.getDonutChartOptions(frequentRecurringJobs, titleFormat, labelFormat);

    var frequentOneOffJobs = data.series[17];
    titleFormat = kendo.format("{0} - Total: {1:n0}", frequentOneOffJobs.name, frequentOneOffJobs.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
    this.frequentOneOffJobsOptions = this.analyticsService.getDonutChartOptions(frequentOneOffJobs, titleFormat, labelFormat);

    var monthlySubscriptionRenewals = data.series[18];
    titleFormat = kendo.format("{0} - Total: {1:n0}", monthlySubscriptionRenewals.name, monthlySubscriptionRenewals.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Customers', dataItem.value)#";
    this.monthlySubscriptionRenewalOptions = this.analyticsService.getDonutChartOptions(monthlySubscriptionRenewals, titleFormat, labelFormat);
  }
}

export default AnalyticsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-revenue/analytics-revenue.controller.js
 **/